<div class="responsive-container p-grid">
  <p-fluid>
  <p-panel>
    <ng-template pTemplate="header">
      <div class="responsive-header">
        <div>
          <span class="responsive-header-title">
            Editar Artículo(s)
            <p class="responsive-header-subtitle">Editar Información de Artículo(s)</p>
          </span>
        </div>
        <div class="flex gap-2 align-items-center">
          <button pButton icon="pi pi-times" class="p-button-rounded p-button-text"
          (click)="onClose()"></button>
        </div>
      </div>
    </ng-template>

    <div class="content">
      <!-- Toast -->
      <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }">
      </p-toast>

      <!-- Dropdown Bodega -->

      <div class="field">
        <label for="warehouse">Bodega</label>
        <p-select id="warehouse" optionLabel="name" optionValue="name" [(ngModel)]="selectedWarehouse"
          [options]="warehouses" placeholder="Selecciona una bodega" [style]="{'width':'100%'}">
        </p-select>
      </div>

      <!-- Edición Masiva -->
      <div class="field field-checkbox">
        <p-checkbox [(ngModel)]="massiveEdit" [binary]="true" inputId="massiveEdit"
          (onChange)="onMassiveEditChange($event)" />
        <label for="massiveEdit"> Edición Masiva
          <button pButton type="button" icon="pi pi-question" [rounded]="true" size="small" class="info-icon-btn"
            pTooltip="Los datos de edición masiva serán aplicados solo a los códigos que sean escaneados teniendo la función activa."
            tooltipPosition="right" tooltipEvent="focus">
          </button>
        </label>
      </div>

        <!-- Panel Edición Masiva -->
        @if (massiveEdit) {
          <div class="field massive-panel">
            <div class="flex justify-content-between align-items-start">
              <div>
                <b>Datos de Edición Masiva</b>
                <br> <br>
                @if (massiveEditData.serialNumber) {
                  <div><b>SKU:</b>
                {{massiveEditData.serialNumber}}</div>
              }
              @if (massiveEditData.description) {
                <div><b>Descripción:</b>
                {{massiveEditData.description}}
              </div>
            }
          </div>
          <a class="edit-link" (click)="updateMassiveData()">Editar</a>
        </div>
      </div>
    }

    <!-- Código Manual -->
    <div class="field">
        <label for="manualQr">Código QR</label>
        <input id="manualCode" type="text" pInputText placeholder="Escanea el Código QR"
          [(ngModel)]="manualQrCode" (input)="onManualInputChange()" />
      </div>
      <!-- Tabla Items -->
      <div class="field">
        <p-table [value]="scannedArticles" dataKey="item.itemId"
          styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th>QR Actualizados</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-expanded="expanded">
            <tr>
              <td colspan="5">
                <div class="flex align-items-center justify-content-between w-full">
                  <div class="flex align-items-center">
                    <button type="button" pButton pRipple [pRowToggler]="row"
                      class="p-button-text p-button-rounded p-button-plain mr-2"
                      [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                    </button>
                    <span class="font-bold ml-2">{{ row.item.code }}</span>
                  </div>
                  <div>
                    <button pButton type="button" icon="pi pi-ellipsis-h"
                      class="p-button-text p-button-rounded" (click)="menu.toggle($event)">
                    </button>
                    <p-menu #menu [popup]="true" [model]="getRowMenuItems(row)" appendTo="body"
                    [autoZIndex]="true"></p-menu>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="expandedrow" let-row>
            <tr>
              <td colspan="2">
                <ul>
                  @for (field of row.changes | keyvalue; track field) {
                    <div>
                      @if (field.value) {
                        <li>
                          <b>{{ getFieldLabel($any(field.key)) }}:</b>
                          {{ getFieldDisplayValue($any(field.key), field.value) }}
                        </li>
                      }
                    </div>
                  }
                </ul>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- Botones -->
      <div class="p-col-12 flex justify-content-between">
        <p-button label="Cancelar" severity="secondary" (click)="onClose()"></p-button>
        <p-button label="Confirmar" (click)="onUpdateArticles()"
        [disabled]="!scannedArticles.length"></p-button>
      </div>
    </div>
  </p-panel>

  <!-- Dialog Edit Item-->
  <p-dialog header="Editar Artículo" [visible]="showEditDialog" [modal]="true"
    [style]="{width: 'clamp(320px, 92vw, 520px)', 'min-height': '100%'}" [closable]="false" [dismissableMask]="false">
    <div class="content">
      @if (articleForm.get('code')?.value) {
        <div class="field">
          <p-chip [label]="articleForm.get('code')?.value"><strong>Código:</strong></p-chip>
        </div>
      }

      <form [formGroup]="articleForm">
        <!-- SKU -->
        <div class="field">
          <label>SKU</label>
          <input type="text" pInputText formControlName="serialNumber" placeholder="Número de Serie" />
        </div>

        <!-- Descripción -->
        <div class="field">
          <label>Descripción <span class="req">*</span></label>
          <input type="text" pInputText formControlName="description"
            placeholder="Descripción del Artículo" />
        </div>

        <!-- Cantidad -->
        <div class="field">
          <label>Cantidad de artículos <span class="req">*</span></label>
          <p-inputNumber formControlName="quantity" [min]="1" [max]="100000" [showButtons]="true"
            placeholder="Cantidad">
          </p-inputNumber>
        </div>

        <!-- Nota -->
        <div class="field">
          <label>Nota <span class="req">*</span></label>
          <textarea pInputTextarea rows="3" class="w-full notes-field" formControlName="notes"></textarea>
          @if (articleForm.dirty) {
            <small class="p-error">
              Por favor, explique el motivo del cambio.
            </small>
          }
        </div>

        <!-- Botones -->
        <div class="p-col-12 flex justify-content-between">
          <p-button label="Cancelar" severity="secondary" (click)="onCloseEdit()"></p-button>
          <p-button label="Guardar" (click)="onSaveArticle()"
          [disabled]="articleForm.pristine || articleForm.invalid"></p-button>
        </div>
      </form>
    </div>
  </p-dialog>

  <!-- Dialog Massive Edit Item-->
  <p-dialog header="Editar Artículos Masivamente" [visible]="showMassiveEditDialog" [modal]="true"
    [style]="{width: 'clamp(320px, 92vw, 520px)', 'min-height': '100%'}" [closable]="false" [dismissableMask]="false">
    <div class="content">

      <form [formGroup]="massiveArticleForm">

        <!-- SKU -->
        <div class="field">
          <label>SKU</label>
          <input type="text" pInputText formControlName="serialNumber" placeholder="Número de Serie" />
        </div>

        <!-- Descripción -->
        <div class="field">
          <label>Descripción</label>
          <input type="text" pInputText formControlName="description"
            placeholder="Descripción del Artículo" />
        </div>

        <!-- Nota -->
        <div class="field">
          <label>Nota <span class="req">*</span></label>
          <textarea pInputTextarea rows="3" class="w-full notes-field" formControlName="notes"></textarea>
        </div>

        <!-- Botones -->
        <div class="p-col-12 flex justify-content-between">
          <p-button label="Cancelar" severity="secondary" (click)="onCloseMassiveEdit()"></p-button>
          <p-button label="Guardar" (click)="onSaveMassiveArticle()"
          [disabled]="!canSaveMassiveEdit"></p-button>
        </div>
      </form>
    </div>
  </p-dialog>
  </p-fluid>
</div>
<p-confirmDialog position="top">
  <ng-template pTemplate="message" let-message>
    <span [innerHTML]="message.message"></span>
  </ng-template>
</p-confirmDialog>